<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch"
                 label-width="80px">
            <el-form-item label="标题" prop="title">
                <el-input
                    v-model="queryParams.title"
                    placeholder="请输入标题"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="权限" prop="quan">
                <el-select v-model="queryParams.quan" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    v-hasPermi="['fang:tongzhi:add']"
                >新增
                </el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    v-hasPermi="['fang:tongzhi:edit']"
                >修改
                </el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    v-hasPermi="['fang:tongzhi:remove']"
                >删除
                </el-button>
            </el-col>

            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>

        <el-table v-loading="loading" :data="tongzhiList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"/>
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="标题" align="center" prop="title"/>
            <el-table-column label="内容" align="center" prop="content"/>
            <!--      <el-table-column label="图片" align="center" prop="img" width="100">-->
            <!--        <template slot-scope="scope">-->
            <!--          <image-preview :src="scope.row.img" :width="50" :height="50"/>-->
            <!--        </template>-->
            <!--      </el-table-column>-->
            <el-table-column label="置顶" align="center" prop="quan">
                <template slot-scope="scope">
                    <label v-if="scope.row.zhi=='1'">置顶</label>
                    <label v-if="scope.row.zhi=='2'">不置顶</label>
                </template>
            </el-table-column>
            <el-table-column label="权限" align="center" prop="quan">
                <template slot-scope="scope">
                    <label v-if="scope.row.quan=='1'">游客可见</label>
                    <label v-if="scope.row.quan=='2'">租客可见</label>
                    <label v-if="scope.row.quan=='3'">全部可见</label>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" prop="createTime"/>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"
                        v-hasPermi="['fang:tongzhi:edit']"
                    >修改
                    </el-button>
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"
                        v-hasPermi="['fang:tongzhi:remove']"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改通知管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入标题"/>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="请输入内容"
                        v-model="form.content">
                    </el-input>
                </el-form-item>
                <!--        <el-form-item label="图片">-->
                <!--          <image-upload v-model="form.img"/>-->
                <!--        </el-form-item>-->
                <el-form-item label="置顶" prop="zhi">
                    <el-radio-group v-model="form.zhi">
                        <el-radio :label="1">置顶</el-radio>
                        <el-radio :label="2">不置顶</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="权限" prop="quan">
                    <el-radio-group v-model="form.quan">
                        <el-radio :label="1">游客可见</el-radio>
                        <el-radio :label="2">租客可见</el-radio>
                        <el-radio :label="3">全部可见</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {listXuzhi, getXuzhi, delXuzhi, addXuzhi, updateXuzhi} from "@/api/homestay/api";

export default {
    name: "Tongzhi",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 通知管理表格数据
            tongzhiList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                title: null,
                content: null,
                img: null,
                quan: null,
                zhi: null,
            },
            options: [{
                value: '1',
                label: '游客'
            }, {
                value: '2',
                label: '租客'
            }, {
                value: '3',
                label: '全部'
            }],
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                title: [
                    {required: true, message: "标题不能为空", trigger: "blur"}
                ],
                content: [
                    {required: true, message: "内容不能为空", trigger: "blur"}
                ],
                img: [
                    {required: true, message: "图片不能为空", trigger: "blur"}
                ],
                quan: [
                    {required: true, message: "权限不能为空", trigger: "blur"}
                ],
                zhi: [
                    {required: true, message: "置顶不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询通知管理列表 */
        getList() {
            this.loading = true;
            listXuzhi(this.queryParams).then(response => {
                this.tongzhiList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                title: null,
                content: null,
                img: null,
                quan: null,
                zhi: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加通知管理";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const idss = (row.id || this.ids.join(','));
            getXuzhi({'id': idss}).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改通知管理";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateXuzhi(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addXuzhi(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除数据项？').then(function () {
                return delXuzhi({'ids': idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            // this.download('fang/xuzhi/export', {
            //     ...this.queryParams
            // }, `xuzhi_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
